module.exports = __webpack_public_path__ + "static/media/X-symbol-black.c61875eb.svg";